import { Injectable } from '@angular/core';
import { matchesUrlLikeServiceWorker } from 'src/app/shared/utils/cross-functions';

@Injectable({
  providedIn: 'root',
})
export class SwCacheService {
  constructor() {}

  async deleteApiCache(dataGroupName: string, urlsPatterns: string[] | null = null) {
    const deletionPromises: Promise<boolean>[] = [];
    const cacheStorage = window.caches;
    // Get all caches
    const cacheNames = await cacheStorage.keys();

    // Iterate over each cache
    for (const cacheName of cacheNames) {
      if (cacheName.startsWith('ngsw:') && cacheName.includes(`${dataGroupName}:cache`)) {
        const cache = await cacheStorage.open(cacheName);
        const requests = await cache.keys();

        for (const request of requests) {
          const url = request.url.toLowerCase();
          if (urlsPatterns) {
            for (const pattern of urlsPatterns) {
              if (matchesUrlLikeServiceWorker(url, pattern.toLowerCase())) {
                deletionPromises.push(cache.delete(request));
              }
            }
          } else {
            deletionPromises.push(cache.delete(request));
          }
        }
      }
    }

    await Promise.all(deletionPromises);
  }
}
